import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
/* stylelint-disable declaration-block-no-duplicate-properties */
export const Grid = styled.div`
  /* Basic fallback for IE11 */

  display: flex;
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: ${props =>
    props.columnTemplate ||
    `repeat(${props.columnCount}, minmax(${props.columnMinWidth}, ${props.columnMaxWidth}))`};
  grid-gap: ${props => props.gap};

  > * {
    /* grid-gap fallback for IE11 */
    ${props =>
      props.gap &&
      css`
        margin-bottom: ${props.gap};
        margin-right: ${props.gap};
      `}

    @supports (display: grid) {
      margin-bottom: 0;
      margin-right: 0;
    }
  }
`;
/* stylelint-enable declaration-block-no-duplicate-properties */
const { string, node, number, oneOfType } = PropTypes;

Grid.propTypes = {
  children: node,
  columnCount: oneOfType([string, number]),
  columnMinWidth: string,
  columnMaxWidth: string,
  columnTemplate: string,
  gap: string,
};
Grid.defaultProps = {
  children: undefined,
  columnCount: 'auto-fill',
  columnMinWidth: 'auto',
  columnMaxWidth: '1fr',
  columnTemplate: undefined,
  gap: '10px',
};
